export const CUSTOM_LIMITS = {
  1005: {
    agencies: {
      1: 100000,
      295: 100000,
      313: 100000
    },
    accounts: {
      29: 100000,
      27: 100000,
      28: 100000,
    }
  }
};
